import React from "react";
// import Navbar from "../components/Navbar";
import Home from "../components/pages/Home";
// import FooterContainer from "../components/pages/FooterContainer";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Services from "../components/pages/Services";
import AboutUs from "../components/pages/AboutUs";
import ContactUs from "../components/pages/ContactUs";
import TermsOfUse from "../components/pages/TermsOfUse";
import Security from "../components/pages/Security";
import Privacy from "../components/pages/Privacy";
import BecomeAgent from "../components/pages/BecomeOurAgent/BecomeAgent";
import Invest from "../components/pages/Invest";
import SignIn from "../components/pages/signin/SignIn";
import EmailVerification from "../components/pages/signup-verify/EmailVerification";
import SignUp from "../components/pages/signup/SignUp";

import Marketing from "../components/pages/Marketing";
import Consulting from "../components/pages/Consulting";
// import Founder from "../components/pages/Founder";

import Dashboard from "../components/pages/dashboard/index";
import ForgetPassword from "../components/pages/forgetpassword/ForgetPassword";
import ResetPassword from "../components/pages/forgetpassword/RessetPassword";
import Faqs from "./../components/pages/Faqs";
import ErrPage from "../components/404Page/404Page";
import { ModalContainer } from "../components/modals/modal";
import ScrollToTop from "../components/pages/ScrollToTop";

const AppRoute = () => {
  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/services" component={Services} />
          <Route path="/about" component={AboutUs} />
          <Route path="/investment" component={Invest} />
          {/* <Route path="/sign-up" component={SignUp} /> */}
          <Route path="/marketing" component={Marketing} />
          <Route path="/contact" component={ContactUs} />
          <Route path="/consulting" component={Consulting} />
          <Route path="/agent" exact component={BecomeAgent} />
          <Route path="/terms" component={TermsOfUse} />
          <Route path="/security" component={Security} />
          <Route path="/privacy" component={Privacy} />
          {/* <Route path="/dashboard" component={Dashboard} /> */}
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/login" component={SignIn} />
          <Route path="/login" component={SignIn} />
          <Route path="/faqs" component={Faqs} />

          <Route path="/signupverify" component={EmailVerification} />
          <Route path="/forgetpassword" component={ForgetPassword} />
          <Route path="/resetpassword" component={ResetPassword} />

          <Route path="/signup" component={SignUp} />
          <Route>
            <ErrPage />
          </Route>
          {/* <Route path="/founder" component={Founder} /> */}
        </Switch>
        {/* <FooterContainer /> */}
        <ModalContainer />
      </ScrollToTop>
    </Router>
  );
};

export default AppRoute;
